import { PetitionUnderReviewBanner } from 'src/app/shared/components/banners/petitionUnderReview';

import { usePageBanner } from './hooks/usePageBanner';

export function PageBanner() {
	const {
		data: { showUnderReviewBanner },
	} = usePageBanner();

	if (!showUnderReviewBanner) return null;

	return <PetitionUnderReviewBanner />;
}
